module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/credit-cards/amex-e9cb738f581f5b5457ce6b9baf869033.jpg";